import * as React from "react";
import type { SVGProps } from "react";
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#flag_svg__a)">
      <path d="M5 4H3c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M4 22c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1" />
      <path d="M17.41 17.96c-1.81 0-3.56-.52-5.19-1-2.7-.79-5.24-1.54-7.71-.1a1 1 0 0 1-1.37-.36 1 1 0 0 1 .36-1.37c3.22-1.89 6.44-.93 9.29-.1 2.44.72 4.76 1.4 7.01.45-.3-1.04-.74-2.9-.74-4.91 0-1.61.17-2.9.37-3.86-2.51.63-4.97-.1-7.2-.76-2.7-.79-5.24-1.54-7.71-.1a1 1 0 0 1-1.37-.36 1 1 0 0 1 .36-1.37c3.22-1.89 6.44-.94 9.29-.1 2.7.79 5.24 1.54 7.71.1.39-.23.87-.17 1.2.14s.4.79.19 1.19c0 0-.83 1.67-.83 5.11 0 2.62.88 5.05.89 5.08.17.45-.02.96-.43 1.21-1.37.81-2.75 1.09-4.1 1.09z" />
    </g>
    <defs>
      <clipPath id="flag_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFlag;
